import { create } from 'zustand';
import { auth } from '../firebase/firebase';
import { onAuthStateChanged, User } from 'firebase/auth';

interface AuthState {
    authUser: User | null;
    fetchingAuth: boolean;
    setAuthUser: (user: User | null) => void;
    setFetchingAuth: (fetching: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    authUser: null,
    fetchingAuth: true,
    setAuthUser: (user) => set({ authUser: user }),
    setFetchingAuth: (fetching) => set({ fetchingAuth: fetching }),
}));

// Initialize listener
onAuthStateChanged(auth, (user) => {
    useAuthStore.getState().setAuthUser(user);
    useAuthStore.getState().setFetchingAuth(false);
});
